import React from "react";

import { useDropzone } from "react-dropzone";

import styles from "./DropZone.module.scss";

interface Props {
  accept?: string | string[];
  children: React.ReactNode;
  maxFiles?: number;
  maxSize?: number;
  onSelect: (files: File[]) => void;
}

const DropZone = ({ accept, children, maxFiles, maxSize, onSelect }: Props) => {
  const { getInputProps, getRootProps } = useDropzone({
    accept,
    maxFiles,
    maxSize,
    onDrop: onSelect,
  });

  return (
    <div className={styles.container} {...getRootProps()}>
      {/* eslint-disable-next-line react/forbid-elements -- file input managed by react-dropzone, no project wrapper exists */}
      <input {...getInputProps()} />
      {children}
    </div>
  );
};

export default DropZone;
